// // src/App.js
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import './App.css'; // Create a CSS file for styling
import Login from './Components/Pages/SignIn/Login';
import SignUp from './Components/Pages/SignIn/SignUp';
import LandingPage from './Components/Pages/LandingPage/LandingPage';
import GuestPage from './Components/Pages/Guest/GuestPage'
import GuestWaitingPage from './Components/Pages/Guest/GuestWaitingPage'
import Footer from './Components/common/Footer/Footer'
import { FixedHeader } from './Components/common/Header/StandardHeader'
import DashboardHome from './Components/Pages/Host/Home';

const App = () => {
  return (
    <>
      <FixedHeader />
      <div className={'container-fluid app-container'}>
        <Routes>
          <Route path="/" index element={<LandingPage />} />
          <Route path="/join" element={<GuestPage />} />
          <Route path="/join/:queueId" element={<GuestPage />} />
          <Route path="/join/token" element={<GuestWaitingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/dashboard/*" element={<DashboardHome />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};
export default App;